import { settingsApi, ssoApi } from './apiClients';

export function authorizeRequest() {
    return settingsApi.get('/sso');
}

export function refreshTokenRequest() {
    return ssoApi.put('/auth/refresh');
}
